import { render } from "./UserAgreementPage.vue?vue&type=template&id=3198d4f7&scoped=true"
const script = {}

import "./UserAgreementPage.vue?vue&type=style&index=0&id=3198d4f7&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3198d4f7"]])

export default __exports__